import api from './api';
import type {PageResponse, ResearchReportDetail, ResearchReportSummary,} from '../types/researchReport';
import type {CompleteChartData} from './tradingService';

/** 研报品种常量列表（前端下拉/侧栏） */
export async function getResearchReportSymbols(): Promise<string[]> {
    const res = await api.get('/api/v1/research-reports/symbols');
    return res.data?.data ?? [];
}

/** 某品种研报列表（摘要分页，按批次时间倒序，含失败记录） */
export async function getResearchReportList(
    symbol: string,
    page: number = 0,
    size: number = 30,
): Promise<PageResponse<ResearchReportSummary>> {
    const res = await api.get('/api/v1/research-reports/list', {params: {symbol, page, size}});
    return res.data?.data ?? {content: [], totalElements: 0, totalPages: 0, number: 0, size};
}

/** 该品种最新一份研报全文（页面默认加载） */
export async function getResearchReportLatest(symbol: string): Promise<ResearchReportDetail | null> {
    const res = await api.get(`/api/v1/research-reports/latest/${symbol}`);
    return res.data?.data ?? null;
}

/** 按 id 查研报全文 */
export async function getResearchReportDetail(id: number): Promise<ResearchReportDetail | null> {
    const res = await api.get(`/api/v1/research-reports/${id}`);
    return res.data?.data ?? null;
}

/** 手动触发生成（调试/补生成；同批次已成功返回已有记录） */
export async function generateResearchReport(symbol: string): Promise<ResearchReportDetail | null> {
    const res = await api.post(`/api/v1/research-reports/generate/${symbol}`);
    return res.data?.data ?? null;
}

/** 研报 K 线快照（历史回溯读库）：现货/永续 × 5m/1H/1D × 240 根 + 生成时刻冻结指标 */
export async function getResearchKline(
    reportId: number,
    swap: boolean,
    timeframe: string,
): Promise<CompleteChartData | null> {
    const query = new URLSearchParams();
    query.append('swap', String(swap));
    query.append('timeframe', timeframe);
    const res = await api.get(`/api/v1/research-reports/kline/${reportId}?${query.toString()}`);
    return res.data?.data ?? null;
}
